module.exports = __webpack_public_path__ + "workspace/static/img/psaThree.9b89a1b.png";